import React from 'react';

import styled from '../../styled-components';

const ErrorDisplay = ({ children }: { children: React.ReactNode }) => (
  <ErrorDisplayCmp>{children}</ErrorDisplayCmp>
);

const ErrorDisplayCmp = styled.span.attrs({
  className: `form-input-validation-message`,
})`
  color: red;
  font-size: 0.8rem;
  text-transform: lowercase;
`;

export default ErrorDisplay;
